import styled from 'styled-components/macro'
import { ReactComponent as calendar } from './calendar.svg'
import { ReactComponent as clock } from './clock.svg'
import { ReactComponent as video } from './video.svg'
import { ReactComponent as people } from './people.svg'
import { ReactComponent as forwardArrow } from './forward-arrow.svg'
import { ReactComponent as backArrow } from './back-arrow.svg'
import { ReactComponent as officialLinkedIn } from 'icons/officialLinkedin.svg'
import { ReactComponent as officialInstagram } from 'icons/officialInstagram.svg'
import { ReactComponent as officialYoutube } from 'icons/officialYoutube.svg'
import { ReactComponent as facebook } from 'icons/officialFacebook.svg'
import { ReactComponent as twitter } from 'icons/twitter-logo.svg'
import { ReactComponent as briefcase } from './filled-briefcase.svg'
import { FilledBriefcaseIcon } from 'common/icon-components/FilledBriefcaseIcon'

export const Facebook = styled(facebook)`
  height: 1em;
  width: 1em;
`

export const OfficialLinkedin = styled(officialLinkedIn)`
  height: 1em;
  width: 1em;
`

export const OfficialInstagram = styled(officialInstagram)`
  height: 1em;
  width: 1em;
`

export const OfficialYoutube = styled(officialYoutube)`
  height: 1em;
  width: 1em;
`

export const OfficialTwitter = styled(twitter)`
  height: 1em;
  width: 1em;
  fill: ${props => props.theme.colors.accent1};
`

export const Calender = styled(calendar)`
  fill: ${props => props.theme.colors.accent1};
`

export const Clock = styled(clock)`
  fill: ${props => props.theme.colors.accent1};
`

export const Video = styled(video)`
  fill: ${props => props.theme.colors.accent1};
`

export const People = styled(people)`
  fill: ${props => props.theme.colors.accent1};
`

export const ForwardArrow = styled(forwardArrow)`
  fill: ${props => props.theme.colors.secondary} !important;
`

export const BackArrow = styled(backArrow)`
  fill: ${props => props.theme.colors.secondary} !important;
`

export const Briefcase = styled(FilledBriefcaseIcon)`
  && {
    fill: ${props => props.theme.colors.accent1};
    height: 1.25rem;
    width: 1.25rem;
  }
  &&:hover {
    fill: ${props => props.theme.colors.primary};
  }
`
